import { NavLink } from "react-router-dom";

import { useI18n } from "../../shared/i18n";
import { useSession } from "../auth/session";

export function AdminTabs() {
  const { can } = useSession();
  const { t } = useI18n();
  return (
    <nav className="subtabs" aria-label={t("admin.title")}>
      {can("admin:users") && (
        <NavLink to="/admin" end>
          {t("admin.users")}
        </NavLink>
      )}
      {can("admin:roles") && <NavLink to="/admin/roles">{t("admin.roles")}</NavLink>}
      {can("admin:audit") && <NavLink to="/admin/audit">{t("admin.audit")}</NavLink>}
    </nav>
  );
}
